import React from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  useTheme,
  alpha,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const ImageViewer = ({ open, onClose, image }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: alpha(theme.palette.background.paper, 0.95),
          backgroundImage: 'none',
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'common.white',
          bgcolor: alpha(theme.palette.common.black, 0.5),
          '&:hover': {
            bgcolor: alpha(theme.palette.common.black, 0.7),
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ p: 1 }}>
        <Box
          component="img"
          src={image}
          alt="Artwork"
          sx={{
            width: '100%',
            height: 'auto',
            maxHeight: '90vh',
            objectFit: 'contain',
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImageViewer; 